var _rect, _rect2, _rect3, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUdmurtia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 360,
    width: 540,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 360
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 360,
    x: 180,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 360,
    x: 360,
    fill: "#d21"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d21",
    points: "245,105 345,205 195,205 295,105 295,255 195,155 345,155 245,255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdmurtia);
export default __webpack_public_path__ + "static/media/udmurtia.4191bbe6698dd11c79d7fb2a527601e7.svg";
export { ForwardRef as ReactComponent };